(function ($) {
  DJ.addBehavior('resourcesFilter', '.tiles__inner-wrapper', {
    setEqualHeightInit: function (filtered) {
      const tilesWrapper = this.getAttachedElements();
      const stayClass = 'resources-item--stay';

      if (!tilesWrapper) {
        return false;
      }

      /**
       * Set equal height for items.
       */
      const setEqualHeight = (elements) => {
        if (!elements) {
          return false;
        }

        let maxHeight = -1;
        const elementsArr = Array.prototype.slice.call(elements);
        let rowArr = [];
        let previousTop = 0;

        if (elementsArr) {
          elementsArr.forEach((e) => {
            e.style.height = '';
          });

          elementsArr.forEach((e) => {
            const elementTop = e.getBoundingClientRect().top;

            if (elementTop !== previousTop) {
              previousTop = elementTop;
              rowArr = [];
              rowArr.push(e);
              maxHeight = e.offsetHeight;
            } else {
              rowArr.push(e);
              maxHeight = Math.max(maxHeight, e.offsetHeight);
            }

            rowArr.forEach((el) => {
              const rowEl = el;

              rowEl.style.height = `${maxHeight}px`;
            });
          });
        }

        return true;
      };

      Array.prototype.slice.call(tilesWrapper).forEach((item) => {
        let resourcesActivities = item.querySelectorAll('.resources-item__activities');
        let resourcesAnalysis = item.querySelectorAll('.resources-item__analysis');
        let resourcesAttachments = item.querySelectorAll('.resources-item__attachments');
        let resourcesItem = item.querySelectorAll('.resources-item');

        if (filtered) {
          resourcesActivities = item.querySelectorAll(`.${stayClass} .resources-item__activities`);
          resourcesAnalysis = item.querySelectorAll(`.${stayClass} .resources-item__analysis`);
          resourcesAttachments = item.querySelectorAll(`.${stayClass} .resources-item__attachments`);
          resourcesItem = item.querySelectorAll(`.${stayClass} .resources-item`);
        }

        setEqualHeight(resourcesActivities);
        setEqualHeight(resourcesAnalysis);
        setEqualHeight(resourcesAttachments);
        setEqualHeight(resourcesItem);
      });

      return true;
    },
    attach: function (context, settings, behavior) {
      const tilesWrapper = this;
      const filtersCheckboxes = Array.prototype.slice.call(
        tilesWrapper.querySelectorAll('.resources-filters__checkbox-input')
      );
      const resourcesItems = tilesWrapper.querySelectorAll('.resources-item');
      const stayClass = 'resources-item--stay';
      let currentBreakpoint = DJ.bp.name;
      let checkedValues = [];

      if (!resourcesItems) {
        return false;
      }

      /**
       * Init equal height.
       */
      behavior.setEqualHeightInit();

      /**
       * Hide/show resources depending on checkboxes.
       */
      if (filtersCheckboxes.length) {
        filtersCheckboxes.forEach((filterCheckbox) => {
          filterCheckbox.addEventListener('change', (e) => {
            const resourcesFilteredClass = 'resources--filtered';

            // Save checkboxes values in the array.
            if (e.target.checked) {
              checkedValues.push(e.target.value);
            } else {
              checkedValues = checkedValues.filter((arrItem) => arrItem !== e.target.value);
            }

            // If no checkboxes checked, show all items.
            if (!checkedValues.length) {
              tilesWrapper.classList.remove(resourcesFilteredClass);
              behavior.setEqualHeightInit();

              return false;
            }

            // Hide all items when checkbox checked.
            tilesWrapper.classList.add(resourcesFilteredClass);

            const items = tilesWrapper.querySelectorAll('.resources-item');

            Array.prototype.slice.call(items).forEach((item) => {
              const tile = $(item).closest('.tile')[0];

              if (tile && tile.classList.contains(stayClass)) {
                tile.classList.remove(stayClass);
              }
            });

            // Show items depending on checked checkboxes.
            checkedValues.forEach((checkedValue) => {
              const itemsToStay = tilesWrapper.querySelectorAll(`.resources-item--${checkedValue}`);

              Array.prototype.slice.call(itemsToStay).forEach((itemToStay) => {
                const tile = $(itemToStay).closest('.tile')[0];

                if (tile && !tile.classList.contains(stayClass)) {
                  tile.classList.add(stayClass);
                }
              });
            });

            behavior.setEqualHeightInit(true);
            return true;
          });
        });
      }

      /**
       * Recalculate items height on breakpoint change.
       */
      DJ.on('changeBreakpoint', function () {
        setTimeout(function () {
          if (currentBreakpoint !== DJ.bp.name) {
            behavior.setEqualHeightInit();
            currentBreakpoint = DJ.bp.name;
          }
        }, 500);
      });

      return true;
    }
  });
})(jQuery);
